const serviceRoot = 'api/USPSAddress/';

export const AddressValidationEndpoints = {
  getAddress: () => `${serviceRoot}getVerifiedAddress`,
};
